import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { Typography } from '@material-ui/core';
import FormQuestion from '../FormQuestion';
import { isEmpty } from '../../../objectUtils';
import { InfoMessage } from '../../../../common/components';

const styles = theme => ({
    root: {

    },
    scoreHeading: {
        marginBottom: theme.spacing(2),
    },
});

// How to use a Quiz
// On the content-page:
// 1. Add a default element with all the questions
// 2. Add a default element with a Button-question. Text: "Show answers"
// 3. Add a "QuizResponse"-element with no content
// 4. Settings for element 3: elementId = id of element 1
// 5. Set the following conditional states:
//      Element 1: Default visible, hidden when "Show answers" is activated
//      Element 2: same as above (or keep always visible..)
//      Element 3: Default hidden, visible when "Show answers" is activated

class QuizResponse extends React.Component {
    render() {
        const {
            classes, element, taskId, translations, getProgramItem, getSpecificTaskResponses, contentState,
        } = this.props;

        if (!element) {
            return null;
        }

        const elementSettings = element.settings || {};
        const quizTaskId = elementSettings.taskId || taskId;
        const quizTask = getProgramItem(quizTaskId);
        const elementId = elementSettings.elementId;

        if (!quizTask || !elementId) {
            return <InfoMessage messageKey="noContent" />;
        }

        const taskResponses = getSpecificTaskResponses(quizTaskId);
        const quizElement = quizTask.contentElements?.find(e => e.id === Number(elementId));
        const questions = quizElement?.questions;

        const questionsWithAnswers = questions?.filter(d => d.answers?.length);

        if (!questionsWithAnswers?.length > 0) {
            return <InfoMessage messageKey="noContent" />;
        }

        if (!taskResponses || isEmpty(taskResponses)) {
            return <InfoMessage messageKey="task.pleaseAnswerQuiz" />;
        }

        const scoring = questionsWithAnswers.reduce((prev, curr) => (
            {
                score: prev.score + Number(taskResponses[curr.id]?.response?.choiceResponse?.reduce((pResp, cResp) => pResp + cResp.score || 0, 0) || 0),
                max: prev.max + Number(curr.answers.reduce((pAnswer, cAnswer) => pAnswer + cAnswer.score || 0, 0)),
            }
        ), { score: 0, max: 0 });

        return (
            <div className={classes.root}>
                <Typography variant="subtitle1" className={classes.scoreHeading} align="right" color="primary">
                    {translations && translations.youGotxOfXScore ? translations.youGotxOfXScore(scoring) : `Score: ${scoring.score} / ${scoring.max}`}
                </Typography>

                {questionsWithAnswers.map(q => (
                    <FormQuestion
                        key={q.id}
                        question={q}
                        response={taskResponses[q.id]?.response}
                        translations={translations}
                        contentState={contentState}
                        elementSettings={elementSettings}
                        showScores
                        handleResponseUpdate={() => {}}
                    />
                ))}
            </div>
        );
    }
}


QuizResponse.propTypes = {
    classes: PropTypes.object.isRequired,
    translations: PropTypes.object,
    element: PropTypes.object.isRequired,
    taskId: PropTypes.string.isRequired,
    getProgramItem: PropTypes.func.isRequired,
    getSpecificTaskResponses: PropTypes.func.isRequired,
    contentState: PropTypes.string,
};

QuizResponse.defaultProps = {
    contentState: null,
    translations: null,
};

export default withStyles(styles)(QuizResponse);
